import { useCallback, useEffect, useRef } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';

import { AppBackground } from '../components/ui/app-background';
import { TabBar, useTabBarHidden } from '../components/ui/tab-bar';
import { useTelegramBackButton } from '../lib/telegram';
import { isTabRoot } from './paths';

export function Layout() {
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const goBack = useCallback(() => void navigate(-1), [navigate]);
	useTelegramBackButton(!isTabRoot(pathname), goBack);
	// One scroll container for every screen: start each new screen at the top.
	const main = useRef<HTMLElement>(null);
	// Open sheets and the chat hide it (T-1302, T-1304).
	const tabBarHidden = useTabBarHidden();
	useEffect(() => {
		if (main.current !== null) main.current.scrollTop = 0;
	}, [pathname]);

	return (
		<div className="pt-safe-top flex h-full flex-col">
			<AppBackground />
			<main ref={main} className="min-h-0 flex-1 overflow-y-auto">
				{/* Each new screen fades in with a small rise (DESIGN → Motion, T-1310). */}
				<div key={pathname} className="animate-page-in h-full">
					<Outlet />
				</div>
			</main>
			{!tabBarHidden && <TabBar />}
		</div>
	);
}
